import { render, staticRenderFns } from "./ProjectGrouping.vue?vue&type=template&id=0279511f&scoped=true&"
import script from "./ProjectGrouping.vue?vue&type=script&lang=js&"
export * from "./ProjectGrouping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0279511f",
  null
  
)

export default component.exports